import { createWithEqualityFn as create } from 'zustand/traditional'
import { shallow } from 'zustand/vanilla/shallow'

import { createSelectors } from '@/shared/lib/createSelectors.ts'

import { searchApiBodyStore } from '../types/searchApiStorePrototype.ts'

export const useSearchAPIStoreBase = createSelectors(
	create(searchApiBodyStore, shallow)
)
export const useSearchAPIStore = createSelectors(useSearchAPIStoreBase)
